import FJScroller from '../../common/components/FJScroller/FJScroller';
import FJUtil from '../../util/FJUtil';
import type { FJDetailsSubtitleItem } from '../../redux/action/FJDetailsPageAction';
import styles from './FJDetailsTranscriptList.module.less';

interface FJDetailsTranscriptListProps {
    subtitleList: FJDetailsSubtitleItem[];
}

export default function FJDetailsTranscriptList({ subtitleList }: FJDetailsTranscriptListProps) {
    return (
        <div className={styles.root}>
            <FJScroller className={styles.scroll}>
                {subtitleList.map((block, idx) => (
                    <div key={`${block.start}-${block.end}-${idx}`} className={styles.block}>
                        <div className={styles.range}>
                            {FJUtil.formatDetailsSubtitleRangeLabel(block.start, block.end)}
                        </div>
                        <div className={styles.text}>{block.text}</div>
                    </div>
                ))}
            </FJScroller>
        </div>
    );
}
